export const apiPaths = {
    addComplaints: '/sr/crm-service-requestsv2',
    editComplaits: '/sr/crm-service-requestsv2',
    addProducts: '/product/crm-products',
    getRegistrations: '/product/products',
    getComplaints: '/sr/service-requests',
    exportData: '/crm/export',
    getInsights: '/crm/insights',
    getList: '/crm/list',
    crmUser: "/users/crm-user",
    identityCrmUser: "/identity/users/crm-user",
    getCategories: '/config/crm-categories',
    uploadFile: '/media/crm-upload',
    statusAndPriority: '/config/complaint-status',
    getModels: '/company/sku',
    qrCode: '/company/qr-code',
    qrGenerator: '/company/qr-generator',
    email: '/email/send-email',
    whatsapp: '/chat/send-message',
    campaign: '/whatsapp-crm/campaign',
    whatsappTemplate: '/whatsapp-crm/template',
    whatsappChannel: '/whatsapp-crm/channel',
    whatsappEmbeddedSignup: '/whatsapp-crm/business',
    companyInfo: '/company/get-info',
    userProfile: '/identity/user-profile',
    whatsappAnalytics: '/whatsapp-crm/analytics',
    entitlements: '/crmv2/entitlements',
    capabilities: '/crmv2/getcapabilities',
    accountSetup: '/crmv2/accountsetup',
    initiatePayment: '/payment/initiate',
    listPlans: '/crmv2/listplans',
    getBillingDetails: '/crmv2/getBillingDetails',
    subscription: '/crmv2/subscription',
    subscriptionStatus: '/payment/subscription-status',
    wallet: '/payment/wallet',
    invoice: '/invoice/invoice',
    reportIssue: '/crmv2/bugreport',
    getConversation: '/whatsapp-chat/conversation-manager',
    automationManager: '/orchestrator/automation-manager',
};
